import { useEffect, useRef, useState } from "react";
import {
  fa,
  gregorianToJalaliParts, gregorianToJalaliText, jalaliToGregorianISO,
  jalaliMonthLength, jalaliFirstWeekdayIndex, JALALI_MONTHS, JALALI_WEEKDAYS,
} from "./data";

function JalaliCalendarPopup({ valueISO, onSelect, onClear }) {
  const baseParts = gregorianToJalaliParts(valueISO || new Date());
  const [viewYear, setViewYear] = useState(baseParts.jy);
  const [viewMonth, setViewMonth] = useState(baseParts.jm);

  const monthLen = jalaliMonthLength(viewYear, viewMonth);
  const leadEmpty = jalaliFirstWeekdayIndex(viewYear, viewMonth);
  const selectedParts = valueISO ? gregorianToJalaliParts(valueISO) : null;
  const todayParts = gregorianToJalaliParts(new Date());

  const cells = [];
  for (let i = 0; i < leadEmpty; i++) cells.push(null);
  for (let d = 1; d <= monthLen; d++) cells.push(d);

  function prevMonth() {
    if (viewMonth === 1) { setViewMonth(12); setViewYear(y => y - 1); }
    else setViewMonth(m => m - 1);
  }
  function nextMonth() {
    if (viewMonth === 12) { setViewMonth(1); setViewYear(y => y + 1); }
    else setViewMonth(m => m + 1);
  }
  function selectDay(d) {
    const iso = jalaliToGregorianISO(viewYear, viewMonth, d);
    if (iso) onSelect(iso);
  }

  return (
    <div className="date-popover" onMouseDown={(e) => e.stopPropagation()}>
      <div className="date-popover-head">
        <button type="button" className="btn btn-icon" onClick={prevMonth}>قبلی</button>
        <div className="date-popover-title">
          <select className="input select month-select" value={viewMonth} onChange={(e) => setViewMonth(Number(e.target.value))}>
            {JALALI_MONTHS.map((m, idx) => <option key={idx} value={idx + 1}>{m}</option>)}
          </select>
          <input className="input year-input" type="number" value={viewYear} onChange={(e) => setViewYear(Number(e.target.value) || viewYear)} />
        </div>
        <button type="button" className="btn btn-icon" onClick={nextMonth}>بعدی</button>
      </div>
      <div className="date-popover-weekdays">
        {JALALI_WEEKDAYS.map(w => <span key={w}>{w}</span>)}
      </div>
      <div className="date-popover-grid">
        {cells.map((d, idx) => {
          if (d === null) return <span key={"e" + idx} className="date-cell empty"></span>;
          const isSelected = selectedParts && selectedParts.jy === viewYear && selectedParts.jm === viewMonth && selectedParts.jd === d;
          const isToday = todayParts.jy === viewYear && todayParts.jm === viewMonth && todayParts.jd === d;
          return (
            <button
              type="button"
              key={d}
              className={"date-cell" + (isSelected ? " selected" : "") + (isToday ? " today" : "")}
              onClick={() => selectDay(d)}
            >{fa(d)}</button>
          );
        })}
      </div>
      {valueISO && <button type="button" className="btn btn-soft date-clear-btn" onClick={onClear}>پاک کردن تاریخ</button>}
    </div>
  );
}

export function DatePickerField({ id, label, valueISO, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div className="filter-field date-field-wrap" ref={wrapRef}>
      <label htmlFor={id}>{label}</label>
      <button id={id} type="button" className={"input date-trigger" + (!valueISO ? " placeholder" : "")} onClick={() => setOpen(o => !o)}>
        {valueISO ? gregorianToJalaliText(valueISO) : "انتخاب تاریخ"}
      </button>
      {open && (
        <JalaliCalendarPopup
          valueISO={valueISO}
          onSelect={(iso) => { onChange(iso); setOpen(false); }}
          onClear={() => { onChange(""); setOpen(false); }}
        />
      )}
    </div>
  );
}
